import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { User } from '@deckplan.io/common/users';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CardPickerComponent } from './cards/card-picker/card-picker.component';
import { Gtag } from 'angular-gtag';
import { ThemeService } from './common/theme/theme.service';
import pkg from '../../package.json';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    public currentUser: User;
    public bannersRetrieved = 1;
    public readonly version = pkg.version;

    private readonly defaultTheme = 'blue-grey-theme';

    constructor(public readonly authService: AuthService,
                private readonly router: Router,
                private readonly dialog: MatDialog,
                private readonly themes: ThemeService,
                private readonly gtag: Gtag /* Do not remove gtag, it needs to be here for Google Analytics */) {}

    public ngOnInit() {
        this.authService.currentUser.subscribe(user => {
            this.currentUser = user;
            if (user) {
                const theme = localStorage.getItem(`${user.alias}:deckplan-theme`) || this.defaultTheme;
                this.switchTheme(theme);
            } else {
                this.switchTheme(this.defaultTheme);
            }
        });

        this.router.events.subscribe((event: RouterEvent) => {
            const main = document.getElementsByClassName('main')[0];
            const container = document.getElementsByTagName('mat-sidenav-container')[0];
            const content = document.getElementsByTagName('mat-sidenav-content')[0];
            const nonAppPath = /(\/(\?.*)?$|.*login.*|.*reset.*|.*features.*|.*pricing.*|.*contact.*|.*privacy.*|.*terms.*|.*signup.*|.*verify.*)/;
            const bothNonAndAppPath = /(\/(\?.*)?$|.*share.*)|.*public.*/;
            if (event instanceof NavigationEnd && (event.url.match(nonAppPath) || (!this.currentUser && event.url.match(bothNonAndAppPath)))) {
                main.classList.add('landing-page');
                container.classList.add('landing-page');
                content.classList.add('landing-page');
            } else if (event instanceof NavigationEnd) {
                main.classList.remove('landing-page');
                container.classList.remove('landing-page');
                content.classList.remove('landing-page');
            }
        });
    }

    public logout() {
        this.authService.logout();
    }

    public switchTheme(theme: string) {
        const body = document.getElementsByTagName('body')[0];
        body.removeAttribute('class');
        body.classList.add(theme);
        if (this.currentUser) {
            localStorage.setItem(`${this.currentUser.alias}:deckplan-theme`, theme);
        }

        if (theme.includes('dark')) {
            this.themes.setDarkTheme();
        } else {
            this.themes.setLightTheme();
        }
    }

    public goToHome() {
        this.router.navigate(['home']);
    }

    public goToDecks() {
        this.router.navigate(['decks']);
    }

    public goToPublicDecks() {
        this.router.navigate(['decks/public']);
    }

    public goToInventory() {
        this.router.navigate(['inventory']);
    }

    public goToAdminDashboard() {
        this.router.navigate(['admin/dashboard']);
    }

    public goToProfile() {
        this.router.navigate(['users', this.currentUser.id]);
    }

    public openCardSearch() {
        this.dialog.open(CardPickerComponent, {
            width: '100vw',
            maxWidth: '100vw',
            height: `calc(100vh - 10%)`,
            disableClose: false,
            data: {
                showOwnedCardsSelector: true
            }
        });
    }
}
